import { useEffect, useRef } from "react";

/**
 * Hook para rastrear PageView no Meta Pixel em Single Page Applications (SPA).
 * - Exclui qualquer rota administrativa (/admin ou #admin) para manter as métricas de tráfego limpas.
 * - Não dispara em âncoras comuns de scroll na página.
 */
export function usePixelPageView() {
  const lastPathname = useRef(
    typeof window !== "undefined" ? window.location.pathname : "/"
  );

  useEffect(() => {
    const handleRouteChange = () => {
      const currentPath = window.location.pathname;
      const currentHash = window.location.hash;
      const isAdminRoute = currentPath.includes("admin") || currentHash.includes("admin");

      if (currentPath !== lastPathname.current) {
        lastPathname.current = currentPath;
        if (typeof window !== "undefined" && window.fbq && !isAdminRoute) {
          window.fbq("track", "PageView");
          console.log(
            "%c🎯 [Meta Pixel] Evento: PageView",
            "background: #4267B2; color: #fff; font-weight: bold; padding: 2px 8px; border-radius: 4px;"
          );
        }
      }
    };

    window.addEventListener("popstate", handleRouteChange);

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, []);
}
